export const BLACK = 'BLACK'
export const PINK = 'PINK'
export const PURPLE = 'PURPLE'

export const DEFAULT_THEME_NAME = PINK

export const KAWAUI_THEME_MAP = {
  [BLACK]: 'privalia',
  [DEFAULT_THEME_NAME]: 'default',
  [PURPLE]: 'purple'
}

export const GABARIT_SIDES_PADDING_LARGE = 45
export const GABARIT_PADDING_SMALL = 16
export const GABARIT_PADDING_MEDIUM = 24
export const GABARIT_PADDING = 21
